import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Topheader from "../../../../Layout/header/header";
import Sidebar from "../sidebar/sidebar";
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  TextField,
  Snackbar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  fetchFlexMetaDataLabels,
  postFlexMetaDataLabels,
  deleteFlexMetaDataLabel,
} from "../../../../Services/redux/FlexMetaData/FlexMetaDataActions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";

const FlexMetaData = () => {
  const dispatch = useDispatch();
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [flexMetaName, setFlexMetaName] = useState("");
  const [deletedTitle, setDeletedTitle] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const flexMetaDataState = useSelector(
    (state) => state.flexMetaDataReducer.labels
  );

  useEffect(() => {
    dispatch(fetchFlexMetaDataLabels());
  }, []);

  const [dataFromChild, setDataFromChild] = useState("");
  function handleDataFromChild(data) {
    setDataFromChild(data);
  }

  const callPostFlexMetaDataApi = async () => {
    const findIndex = flexMetaDataState.findIndex(
      (label) => label.title.trim() === flexMetaName.trim()
    );
    if (findIndex !== -1) {
      setSnackMsg("Flex metadata already exists.");
      setOpenSnackbar(true);
      setFlexMetaName("");
    } else if (/^[a-zA-Z0-9_-]+$/.test(flexMetaName.trim())) {
      const obj = {};
      obj["title"] = flexMetaName;
      dispatch(
        postFlexMetaDataLabels(sessionStorage.getItem("portfolioId"), obj)
      );
      setAddDialogOpen(false);
      setFlexMetaName("");
      setSnackMsg("");
      setOpenSnackbar(false);
    } else {
      setSnackMsg("Flex metadata can only contain letters, numbers, hyphens (-) and underscores (_).");
      setOpenSnackbar(true);
      setFlexMetaName("");
    }
  };

  const DeleteFlexMetaDataApi = async (title) => {
    setDeletedTitle(title);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteFlexMetaData = () => {
    dispatch(
      deleteFlexMetaDataLabel(
        sessionStorage.getItem("portfolioId"),
        deletedTitle
      )
    );
    setDeleteDialogOpen(false);
    setDeletedTitle("");
  };

  const handleCancel = () => {
    setAddDialogOpen(false);
    setFlexMetaName("");
    setSnackMsg("");
    setOpenSnackbar(false);
  };
  return (
    <>
      <Topheader />
      <Box
        sx={{
          marginTop: "3%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "-webkit-box",
          }}
        >
          <Sidebar
            sendDataToParent={handleDataFromChild}
            page="Flex Metadata"
          />
          <div
            style={{ display: "flex", flexDirection: "column", width: "70%" }}
          >
            <Box
              className="notifications-main- section"
              sx={{ flexGrow: 1, marginLeft: "20px" }}
            >
              <Box
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                width="89%"
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    marginTop: "33px",
                    fontWeight: "500",
                  }}
                >
                  {dataFromChild} - Flex Metadata
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "24px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    borderTop: "1px solid #12141533",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: "500",
                        marginTop: "5px",
                      }}
                    >
                      Flex Metadata
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ textTransform: "none", maxWidth: "none" }}
                      disabled={
                        sessionStorage.getItem("readonly_OemAdmin") === "true"
                      }
                      onClick={() => {
                        setAddDialogOpen(true);
                      }}
                    >
                      Add New Flex Metadata
                    </Button>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    justifyContent: "flexStart",
                    flexDirection: "column",
                    marginLeft: "1px",
                    gap: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "14px",
                      leadingTrim: "NONE",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#717273",
                    }}
                  >
                    Max of 100 flex metadata can be added per portfolio.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "20px",
                    justifyContent: "flexStart",
                    flexDirection: "column",
                    marginLeft: "1px",
                    gap: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 600,
                      fontStyle: "SemiBold",
                      fontSize: "16px",
                      leadingTrim: "NONE",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      verticalAlign: "middle",
                      color: "#2A2C2D",
                    }}
                  >
                    List of flex metadatas
                  </Typography>
                  <TableContainer
                    component={Paper}
                    sx={{
                      mt: 2,
                      maxHeight: 320,
                      overflowY: "auto",
                      scrollBehavior: "smooth",
                      // Custom scrollbar styles
                      "&::-webkit-scrollbar": {
                        width: "8px",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#c1c1c1",
                        borderRadius: "8px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#a1a1a1",
                      },
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>Metadata</TableCell>
                          <TableCell
                            align="right"
                            sx={{ width: 120 }}
                          ></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {flexMetaDataState.map((row) => (
                          <TableRow key={row.title}>
                            <TableCell>{row.title}</TableCell>
                            <TableCell align="right">
                              <IconButton
                                size="small"
                                disabled={
                                  sessionStorage.getItem(
                                    "readonly_OemAdmin"
                                  ) === "true"
                                }
                              >
                                <DeleteIcon
                                  fontSize="small"
                                  onClick={() =>
                                    DeleteFlexMetaDataApi(row.title)
                                  }
                                />
                              </IconButton>
                              <IconButton size="small" sx={{ ml: 1 }} disabled>
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </div>
        </Box>
      </Box>
      <Dialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 500,
            fontSize: "24px",
            fontFamily: "Roboto",
            pb: 0,
          }}
        >
          Add New Flex Metadata
          <IconButton onClick={() => setAddDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2, mt: 1 }}>
            <Typography sx={{ fontWeight: 500, mb: 1, fontSize: "16px" }}>
              Flex Metadata Name <span style={{ color: "#E53935" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Eg: ICON_DOLBY"
              value={flexMetaName}
              onChange={(e) => setFlexMetaName(e.target.value)}
              sx={{ mb: 3 }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end", pb: 2 }}>
          <Button
            onClick={() => handleCancel()}
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              fontFamily: "Roboto",
              background: "#f5f5f5",
              color: "#222",
              borderRadius: "6px",
              px: 4,
              mr: 1,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              // Save logic here
              callPostFlexMetaDataApi();
            }}
            variant="contained"
            sx={{
              ml: 2,
              background: "#0070f3",
              fontWeight: 500,
              fontSize: "16px",
              fontFamily: "Roboto",
              borderRadius: "6px",
              px: 4,
            }}
            disabled={flexMetaName.trim() === ""}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 500,
            fontSize: "24px",
            fontFamily: "Roboto",
            pb: 0,
          }}
        >
          Delete Flex Metadata
          <IconButton onClick={() => setDeleteDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mt: 1, mb: 2, fontSize: "16px", color: "#222" }}>
            Are you sure you wish to permanently remove this Flex Metadata?
            <br />
            <span style={{ color: "#717273" }}>
              This action cannot be reversed.
            </span>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end", pb: 2 }}>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              fontFamily: "Roboto",
              background: "#f5f5f5",
              color: "#222",
              borderRadius: "6px",
              px: 4,
              mr: 1,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              // Call your delete logic here
              confirmDeleteFlexMetaData();
            }}
            variant="outlined"
            sx={{
              ml: 2,
              border: "1px solid #E53935",
              color: "#E53935",
              fontWeight: 500,
              fontSize: "16px",
              fontFamily: "Roboto",
              borderRadius: "6px",
              px: 4,
              background: "#fff",
              "&:hover": {
                background: "#ffeaea",
                borderColor: "#E53935",
              },
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message={snackMsg}
      />
    </>
  );
};

export default FlexMetaData;
